module.exports = __webpack_public_path__ + "img/wallet_01_building.4c8923f3.png";